<script setup lang="ts">
import type { DisciplineProgressReport } from '../model/interfaces'

import { AppText } from '@shared/ui/typography'

import { getProgressReportStatementRows } from '../model/discipline-progress-reports'
import DisciplineProgressReportActions from './DisciplineProgressReportActions.vue'

defineOptions({
  name: 'DisciplineProgressReportDetails',
})

const props = withDefaults(defineProps<{
  report: DisciplineProgressReport
  editable?: boolean
}>(), {
  editable: false,
})

const emit = defineEmits<{
  'click:edit': []
}>()

const refGroups = computed(() => [
  { title: 'Progress gained', rows: getProgressReportStatementRows(props.report.progress_gained) },
  { title: 'Areas for improvement', rows: getProgressReportStatementRows(props.report.to_improve) },
  { title: 'Further steps', rows: getProgressReportStatementRows(props.report.further_steps) },
])
</script>

<template>
  <div :class="['discipline-progress-report-details', { editable }]">
    <div class="discipline-progress-report-details__head">
      <AppText name="body2-medium">
        Positive learning trait
      </AppText>
      <AppText name="body2-medium">
        Topics covered
      </AppText>
      <AppText
        v-for="group in refGroups"
        :key="group.title"
        name="body2-medium"
      >
        {{ group.title }}
      </AppText>
      <span v-if="editable" />
    </div>
    <div class="discipline-progress-report-details__body">
      <AppText name="body2">
        {{ report.positive_trait || '-' }}
      </AppText>
      <AppText
        name="body2"
        class="discipline-progress-report-details__text"
      >
        {{ report.topics || '-' }}
      </AppText>
      <div
        v-for="group in refGroups"
        :key="group.title"
        class="discipline-progress-report-details__statements"
      >
        <div
          v-for="row in group.rows"
          :key="row.title"
          class="discipline-progress-report-details__statement"
        >
          <AppText name="body2-medium">
            {{ row.title }}
          </AppText>
          <AppText
            name="body2"
            class="discipline-progress-report-details__text"
          >
            {{ row.text }}
          </AppText>
        </div>
      </div>
      <DisciplineProgressReportActions
        v-if="editable"
        :report-id="report.id"
        @click:edit="emit('click:edit')"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineProgressReportDetails.scss" />
